"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachFile = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const Colors_1 = require("../../../../../Colors");
const common_1 = require("../../../../../common");
const featureFlags_1 = require("../../../../../common/featureFlags");
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
const account_1 = require("../../../../base/account");
// 첨부 파일 컴포넌트
exports.AttachFile = react_1.default.memo(({ attachFileList, setAttachFileList, isRegist, showRegist = false, isAnswer = false, isTeacher, isRequestion, isLive = false, isColumn = false, download = false, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isDesktop, isTablet, isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    // p46: 관리자도 교사처럼 진행기간 무관 첨부파일 다운로드 허용
    const isManager = (0, react_redux_1.useSelector)((state) => (0, account_1.getIsManager)(state));
    const fileRef = react_1.default.useRef(null);
    //이미지, pdf, 엑셀, 워드, PPT, 텍스트 파일
    const acceptedFileTypes = 'image/*,application/pdf,.xlsx, .xls, .csv, .ppt, .pptx, .pdf, .doc, .docx, .txt, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, text/plain, video/mp4, .mp4, ' +
        (featureFlags_1.MP3_FEATURE_ENABLED ? 'audio/mpeg, .mp3, ' : '') +
        '.zip, application/zip, application/x-zip-compressed';
    // (onClick) 첨부 파일 삭제
    const deleteAttachFile = (item) => {
        setAttachFileList(attachFileList.filter(file => file !== item));
    };
    const downloadFile = (url) => {
        if (!isTeacher && !isManager && !download)
            return;
        const formattedUrl = url.replace(/\s/g, '%20');
        const a = document.createElement('a');
        a.href = formattedUrl; // 다운로드 URL 설정
        a.download = url.split('/').pop() || 'download'; // 다운로드 파일명 설정
        document.body.appendChild(a); // a 요소를 문서에 추가
        a.click();
        document.body.removeChild(a); // a 요소를 문서에서 제거
    };
    // (onChange) 첨부 파일 추가
    const onChangeFile = (e) => {
        const file = e.target.files[0];
        setAttachFileList([...attachFileList, file]);
        if (fileRef.current)
            fileRef.current.value = '';
    };
    //드래그 앤 드롭 파일 막기
    const handleDrop = e => {
        e.preventDefault();
        const dt = e.dataTransfer;
        // 드롭된 항목이 폴더인지 파일인지 확인
        for (let i = 0; i < dt.items.length; i++) {
            const item = dt.items[i];
            if (item.kind === 'file') {
                const file = item.getAsFile();
                // 파일 확장자 확인 (예시: mp4, mov 확장자만 허용)
                if (file.type.startsWith('video/') &&
                    (file.type.includes('mp4') || file.type.includes('quicktime'))) {
                    // 파일 처리 로직 추가
                }
                else {
                    alert('폴더를 등록할 수 없습니다.');
                    return;
                }
            }
            else {
                alert('폴더를 등록할 수 없습니다.');
                return;
            }
        }
    };
    const handleDragOver = e => {
        e.preventDefault();
    };
    const renderAttachFileButton = (0, react_1.useMemo)(() => (react_1.default.createElement(common_1.FileInput, { ref: fileRef, className: "dst_attach_file", id: "dst_attach_file", onChange: onChangeFile, accept: acceptedFileTypes },
        react_1.default.createElement(common_1.Button, { className: `btn_tur ${isDesktop || isAnswer ? 'sm' : isTablet ? 'regist_btn' : 'xxs'}`, text: isMobile
                ? 'assignment.reisgAttachFile'
                : isAnswer
                    ? 'supportRoom.regist'
                    : 'common.regist', styles: {
                buttonWrap: isAnswer
                    ? {
                        width: '60px',
                        height: '30px',
                    }
                    : isLive && isMobile
                        ? { width: '100%' }
                        : {
                            height: isTeacher ? undefined : '45px',
                            width: isMobile && '100%',
                            padding: isMobile && '6px',
                        },
            } }))), [isDesktop, isTeacher, isAnswer, attachFileList]);
    const renderAttachFile = (0, react_1.useMemo)(() => (react_1.default.createElement(react_1.default.Fragment, null,
        isMobile && showRegist && renderAttachFileButton,
        react_1.default.createElement("div", { onDrop: handleDrop, onDragOver: handleDragOver, className: "box", style: {
                width: '100%',
                minHeight: isAnswer
                    ? 50
                    : isTeacher && !isMobile
                        ? 100
                        : isTeacher && isTablet
                            ? 112
                            : undefined,
                // maxHeight: isTeacher && !isTablet ? 100 : undefined,
            } },
            react_1.default.createElement("div", { style: {
                    width: isAnswer ? '85%' : '100%',
                    display: 'inline-flex',
                    flexWrap: 'wrap',
                    flexDirection: 'row',
                    gap: '10px',
                } }, attachFileList.length > 0 ? (attachFileList.map((item, index) => (react_1.default.createElement(common_1.Button, { key: index, className: `btn_sliver md_round center body5 cursor attach_item ${isMobile ? 'mobile-xxs' : ''}`, text: typeof item === 'string'
                    ? item.split('/')[item.split('/').length - 1]
                    : item.name, styles: {
                    buttonWrap: {
                        height: 'fit-content',
                        maxWidth: isMobile ? 180 : 220,
                    },
                }, option: {
                    buttonBeforeIcon: {
                        name: 'file',
                        color: Colors_1.Colors.dark_tur,
                        size: isMobile ? 12 : 20,
                        show: true,
                    },
                    buttonAfterIcon: {
                        name: !showRegist &&
                            !isAnswer &&
                            typeof item === 'string'
                            ? 'file-down'
                            : 'cancel',
                        color: Colors_1.Colors.accent,
                        size: !showRegist &&
                            !isAnswer &&
                            typeof item === 'string'
                            ? 16
                            : 12,
                        show: showRegist || isAnswer
                            ? true
                            : typeof item === 'string',
                    },
                }, onClick: !isTeacher
                    ? download || isManager
                        ? () => downloadFile(item)
                        : () => alert('진행 기간에만 다운로드 가능합니다.')
                    : showRegist || isAnswer
                        ? () => deleteAttachFile(item)
                        : typeof item === 'string'
                            ? () => downloadFile(item)
                            : () => { } })))) : (react_1.default.createElement("p", { className: "body5", style: { color: Colors_1.Colors.light_grey, width: '85%' } }, isTeacher && isRegist
                ? t('assignment.attachFilePlaceholer')
                : t('assignment.noAttachFilePlaceholer')))),
            isAnswer && renderAttachFileButton),
        !isMobile && showRegist && renderAttachFileButton)), [showRegist, isAnswer, attachFileList, isTeacher, isRegist]);
    return (react_1.default.createElement("div", { className: "field-global-001", style: {
            ...(isRequestion ? { gap: '48px' } : { alignItems: 'flex-start' }),
            ...(isColumn && { flexDirection: 'column' }),
        } }, isMobile && isTeacher && isRegist ? (react_1.default.createElement("div", { className: "attach-file-wrap" }, renderAttachFile)) : isLive && isMobile ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "mobile-file-wrap" },
            react_1.default.createElement("div", { className: "task-label" }, t('assignment.attachFile')),
            renderAttachFile))) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: "task-label" }, t('assignment.attachFile'))),
        renderAttachFile))));
});
